import { Injectable } from '@angular/core';

@Injectable()
export class ThumbSourceFactoryService {

    public make(source: string, width: number, height: number) {
        return `https://assets.betalabs.net/fit-in/${+width}x${+height}/filters:fill(white)/`
            + source.replace('https://assets.betalabs.net/', '');
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/services/thumb-source-factory.service.ts